<script>
    import { Tooltip } from 'sveltestrap';
    import { tooltip } from "@svelte-plugins/tooltips";
    
    import AimTooltip from '../component/AimTooltip.svelte'

    // Whether the data should be displayed. This can be used to conditionally hide the cell data. Optionally, the cell can also be highlighted.
    export let display = true;
    export let highlight = false;
    
    // Content properties - Either a text value or an icon can be provided.
    export let text = undefined;
    export let icon = undefined;

    // Display properties - Styling and layout properties for the table data cell.  
    export let iconSize = undefined; // Optional size for the icon. If not provided, the default size will be used.
    export let center = false; // If true, the data will be displayed centered in the table cell. If an icon is provided, this will be set to true automatically.
    export let alignMiddle = false; // If true, the data will be displayed vertically centered in the table cell
    export let classes = undefined;

    // Tooltip properties - An optional tooltip can be added to the table cell.
    export let aimTooltip = false; // Set to true if the tooltip is an AIM tooltip, false for non-AIM tooltips
    export let tooltipId = undefined; // Only required for non-AIM tooltips
    export let tooltipOptions = undefined; // Only required for AIM tooltips
    export let tooltipText = undefined; // Either plain text (non-AIM tooltip) or an array of tooltip lines (AIM tooltip)
</script>

<style>
    :global(td span.table-data-highlighted) {
        background-color: #dce8f0;
        padding: 2px 6px;
        border-radius: 3px;
    }

    :global(td.td-vertical-align-middle) {
        vertical-align: middle;
    }

    :global(td.td-icon-lg) {
        font-size: 16px;
        padding-top: 4px;
        padding-bottom: 0;
    }

    :global(td.td-icon-xl) {
        font-size: 20px;
        padding-top: 1px;
        padding-bottom: 0;
    }
</style>

<td class={classes} 
    class:table-text-center={center || icon}
    class:td-vertical-align-middle={alignMiddle}
    class:td-icon-lg={iconSize && iconSize === 'lg'}
    class:td-icon-xl={iconSize && iconSize === 'xl'}>
    <!-- If display is false, do not render any data inside the cell -->
    {#if display}
        {#if aimTooltip}
            <span use:tooltip={{
                content: {
                    component: AimTooltip,
                    props: tooltipText
                },
                ...tooltipOptions
            }}>
                {#if icon}
                    <i class="bi bi-{icon}" />
                {:else if text}
                    <span>{text}</span>
                {/if}
            </span>
        {:else}
            <!-- If text data or icon is provided display this, otherwise display the slotted data -->
            {#if text || icon}
                <span id={tooltipId} class:table-data-highlighted={highlight}>
                    {#if icon}
                        <i class="bi bi-{icon}" />
                    {:else if text}
                        {text}
                    {/if}
                </span>
            {:else}
                <slot />
            {/if}
            {#if tooltipText && tooltipId}
                <Tooltip target="{tooltipId}" placement="bottom">{tooltipText}</Tooltip>
            {/if}
        {/if}
    {/if}
</td>